import styles from "../../styles";
import { motion } from "framer-motion";
import { themeColors } from "../../config.js";
const letterStyle = {
  fontSize: 25,
  fontFamily: "roboto",
  margin: 10,
  borderRadius: "50%",
  width: 40,
  height: 40,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  color: themeColors.transparentBlack,
  boxShadow: "0 0 5px black",
};
const Loading = ({ style }) => {
  return (
    <div
      style={{
        ...styles.fullScreenContainer,
        backgroundColor: themeColors.backgroundTheme,
        ...style,
      }}
    >
      <motion.div
        style={{ ...letterStyle }}
        animate={{
          backgroundColor: [
            "#CCCCCC",
            "#FF0000",
            "#CCCCCC",
            "#CCCCCC",
            "#CCCCCC",
            "#CCCCCC",
            "#CCCCCC",
          ],
          scale: [1, 1.5, 1, 1, 1, 1, 1],
          rotate: [0, 60, 120, 180, 240, 300, 360],
        }}
        transition={{
          type: "spring",
          duration: 2,
          repeat: Infinity,
          repeatDelay: 1,
        }}
      >
        W
      </motion.div>
      <motion.div
        style={{ ...letterStyle }}
        animate={{
          backgroundColor: [
            "#CCCCCC",
            "#CCCCCC",
            "#FF0000",
            "#CCCCCC",
            "#CCCCCC",
            "#CCCCCC",
            "#CCCCCC",
          ],
          scale: [1, 1, 1.5, 1, 1, 1, 1],
          rotate: [0, 120, 240, 360, 480, 600, 720],
        }}
        transition={{
          type: "spring",
          duration: 2,
          repeat: Infinity,
          repeatDelay: 1,
        }}
      >
        E
      </motion.div>
      <motion.div
        style={{ ...letterStyle }}
        animate={{
          backgroundColor: [
            "#CCCCCC",
            "#CCCCCC",
            "#CCCCCC",
            "#FF0000",
            "#CCCCCC",
            "#CCCCCC",
            "#CCCCCC",
          ],
          scale: [1, 1, 1, 1.5, 1, 1, 1],
          rotate: [0, 180, 360, 540, 720, 900, 1080],
        }}
        transition={{
          type: "spring",
          duration: 2,
          repeat: Infinity,
          repeatDelay: 1,
        }}
      >
        B
      </motion.div>
      <motion.div
        style={{ ...letterStyle }}
        animate={{
          backgroundColor: [
            "#CCCCCC",
            "#CCCCCC",
            "#CCCCCC",
            "#CCCCCC",
            "#FF0000",
            "#CCCCCC",
            "#CCCCCC",
          ],
          scale: [1, 1, 1, 1, 1.5, 1, 1],
          rotate: [0, 120, 240, 360, 480, 600, 720],
        }}
        transition={{
          type: "spring",
          duration: 2,
          repeat: Infinity,
          repeatDelay: 1,
        }}
      >
        O
      </motion.div>
      <motion.div
        style={{ ...letterStyle }}
        animate={{
          backgroundColor: [
            "#CCCCCC",
            "#CCCCCC",
            "#CCCCCC",
            "#CCCCCC",
            "#CCCCCC",
            "#FF0000",
            "#CCCCCC",
          ],
          scale: [1, 1, 1, 1, 1, 1.5, 1],
          rotate: [0, 60, 120, 180, 240, 300, 360],
        }}
        transition={{
          type: "spring",
          duration: 2,
          repeat: Infinity,
          repeatDelay: 1,
        }}
      >
        S
      </motion.div>
    </div>
  );
};
export default Loading;
